import styled from 'styled-components'
export const ErrorTag = styled.div`
  padding: 24px;
  background-color: #F8F8F8;
  border-radius: 10px;
  margin-bottom: 10px;
`

export const TableData = styled.td`
    padding: 10px;
`